import { initializeApp } from 'firebase/app';
import { getDatabase } from 'firebase/database';
import { getAnalytics } from 'firebase/analytics';

const firebaseConfig = {
  apiKey: "AIzaSyAR0e3r5tGuf2DmbPFBQVuqg6iRrzldNgQ",
  authDomain: "timepassgames-45d9b.firebaseapp.com",
  databaseURL: "https://timepassgames-45d9b.firebaseio.com",
  projectId: "timepassgames-45d9b",
  storageBucket: "timepassgames-45d9b.firebasestorage.app",
  messagingSenderId: "970756508796",
  appId: "1:970756508796:web:dae2216927f4062535cdf9",
  measurementId: "G-S00NVBP2EX"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const database = getDatabase(app);
const analytics = getAnalytics(app);

export { database, analytics };
export default app;